import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import Tag, { TagList } from "../Tag"
import ImageContentful from "../ImageContentful"

import { media, mixins } from "../../styles"

const Teaser = styled(Link)`
  color: ${({ theme }) => theme.spaceblue};
  display: block;
  text-decoration: none;
  transition: color ${({ theme }) => theme.transitionTime};

  &:hover {
    color: ${({ theme }) => theme.sun};
  }
`

const Header = styled.h2`
  ${mixins.title3}
`

const Description = styled.div`
  ${mixins.copy4}
`

const Image = styled.div`
  margin: 0 0 30px;
`

const Details = styled.div`
  @media ${media.md} {
    max-width: 85%;
  }
`

const PostTeaser = ({ post, className }) => {
  return (
    <Teaser
      to={`/blog/${post.slug}/`}
      className={`${className || ""} post-teaser`}
    >
      <Image>
        {post.coverImage && (
          <ImageContentful alt={post.title} image={post.coverImage} />
        )}
      </Image>
      {post.categories ? (
        <TagList>
          {post.categories.map((category) => (
            <Tag key={category.name}>{category.name}</Tag>
          ))}
        </TagList>
      ) : null}
      <Details>
        <Header>{post.title}</Header>
        <Description>
          <p>{post.description || post.text?.childMarkdownRemark?.excerpt}</p>
        </Description>
      </Details>
    </Teaser>
  )
}

export default PostTeaser
